export function formatCurrency(value: number, currency: string, locale: undefined | string = undefined) {
    const formatter = Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 0,
    });

    return formatter.format(value);
}
